import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { COPY_CREDIT_APP_EVENT_RECEIVED } from '../../actionTypes/contractingActionTypes';
import { computeStageDurationMs } from '../../selectors/contractingSelectors';
import type { TopicHandler } from './types';

export const handleCopyCreditApp: TopicHandler = (state, event) => {
    if (event.message?.includes?.('subscribe')) return null;

    const message = event.data;
    logNewRelicPageAction('MV:CopyCreditApp:WebSocketReceived', {
        eventName: message?.eventName,
        eventTransactionId: message?.eventTransactionId,
        correlationId: message?.eventKeyData?.correlationId,
        creditAppId: message?.eventKeyData?.creditAppId,
        eventTimestamp: message?.eventTime,
        receivedTimestamp: new Date().toISOString(),
        wsToRenderDelayMs: message?.eventTime ? Date.now() - new Date(message.eventTime).getTime() : null,
        stageDurationMs: computeStageDurationMs(state)
    });

    return {
        type: COPY_CREDIT_APP_EVENT_RECEIVED,
        payload: { ...event, message }
    };
};
